export default __webpack_public_path__ + "static/media/Karin_Bunny_Girl.eee72767.png";